<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopCommunityManage.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="shopCommunityManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-select v-model="shopCommunityManageInfo.conditions.state"
              :placeholder="$t('shopCommunityManage.selectStatus')" style="width:100%">
              <el-option v-for="item in shopCommunityManageInfo.states" :key="item.statusCd" :label="item.name"
                :value="item.statusCd" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="shopCommunityManageInfo.conditions.communityId"
              :placeholder="$t('shopCommunityManage.inputCommunityCode')" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="shopCommunityManageInfo.conditions.communityNameLike"
              :placeholder="$t('shopCommunityManage.inputCommunityName')" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryShopCommunityMethod">
              <i class="el-icon-search"></i> {{ $t('common.query') }}
            </el-button>
            <el-button type="primary" @click="_resetShopCommunityMethod">
              <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopCommunityManage.settledCommunity') }}</div>
        <div class="flex justify-end">
          <el-tooltip :disabled="canApplyShopCommunity" content="请先完成开店审核后再申请入驻小区" placement="top">
            <span>
              <el-button type="primary" :disabled="!canApplyShopCommunity" @click="_openAddShopCommunityModal">
                <i class="el-icon-plus"></i> {{ $t('shopCommunityManage.settle') }}
              </el-button>
            </span>
          </el-tooltip>
        </div>
      </div>
      <div class="">
        <el-table :data="shopCommunityManageInfo.shopCommunitys" border style="width: 100%">
          <el-table-column prop="communityId" :label="$t('shopCommunityManage.communityCode')" align="center" />
          <el-table-column prop="communityName" :label="$t('shopCommunityManage.communityName')" align="center" />
          <el-table-column :label="$t('shopCommunityManage.deliveryType')" align="center">
            <template #default="scope">
              {{ deliveryTypeName(scope.row.deliveryType) }}
            </template>
          </el-table-column>
          <el-table-column prop="address" :label="$t('shopCommunityManage.communityAddress')" align="center" />
          <el-table-column prop="codeName" :label="$t('shopCommunityManage.cityCode')" align="center" />
          <el-table-column prop="createTime" :label="$t('shopCommunityManage.settleTime')" align="center" :formatter="formatDateTimeCell" />
          <el-table-column prop="startTime" :label="$t('shopCommunityManage.startTime')" align="center" :formatter="formatDateTimeCell" />
          <el-table-column prop="endTime" :label="$t('shopCommunityManage.endTime')" align="center" :formatter="formatDateTimeCell" />
          <el-table-column prop="stateName" :label="$t('shopCommunityManage.status')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="150">
            <template #default="scope">
              <el-button size="mini" @click="_openEditShopCommunityModel(scope.row)">
                {{ $t('shopCommunityManage.edit') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteShopCommunityModel(scope.row)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="shopCommunityManageInfo.conditions.page"
          :page-size="shopCommunityManageInfo.conditions.row" layout="total, prev, pager, next"
          :total="shopCommunityManageInfo.total" />
      </div>
    </el-card>

    <add-shop-community ref="addShopCommunity" @refresh="_queryShopCommunityMethod" />
    <edit-shop-community ref="editShopCommunity" @refresh="_queryShopCommunityMethod" />
    <delete-shop-community ref="deleteShopCommunity" @refresh="_queryShopCommunityMethod" />
  </div>
</template>

<script>
/*
 * 服务码调用点清单（Task 21B，REQ20260904014）：
 * 1. shop.queryShop —— 当前店铺状态核定（getShopList 封装，判定是否可申请入驻小区）
 * 2. shop.queryShopCommunity —— 已入驻小区列表（响应已含 deliveryType 列，21A mapper 别名确认）
 * 3. shop.saveShopCommunity —— 新增入驻（addShopCommunity 弹窗，deliveryType 空值不 put 键）
 * 4. shop.updateShopCommunity —— 修改配送类型（editShopCommunity 弹窗，deliveryType 空值不 put 键）
 * 5. shop.deleteShopCommunity —— 删除入驻小区
 */
import { getDict } from '@/api/shop/shopApi'
import { queryShopCommunity } from '@/api/goods/shopCommunityApi'
import { getShopId, getShop, getShopList } from '@/api/shop/shopApi'
import AddShopCommunity from '@/components/goods/addShopCommunity/addShopCommunity.vue'
import EditShopCommunity from '@/components/goods/editShopCommunity/editShopCommunity.vue'
import DeleteShopCommunity from '@/components/goods/deleteShopCommunity/deleteShopCommunity.vue'

export default {
  name: 'ShopCommunityManage',
  components: {
    AddShopCommunity,
    EditShopCommunity,
    DeleteShopCommunity
  },
  data() {
    return {
      shopCommunityManageInfo: {
        shopCommunitys: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          state: '',
          communityId: '',
          communityNameLike: '',
          shopId: '',
          page: 1,
          row: 10
        }
      },
      currentShopState: ''
    }
  },
  computed: {
    canApplyShopCommunity() {
      return this.currentShopState === '002'
    }
  },
  created() {
    this._initData()
  },
  methods: {
    formatDateTimeCell(row, column, cellValue) {
      if (!cellValue) return ''
      return String(cellValue).replace('T', ' ').substring(0, 19)
    },
    deliveryTypeName(deliveryType) {
      if (deliveryType === 'STORE') {
        return this.$t('shopCommunityManage.deliveryTypeStore')
      }
      if (deliveryType === 'PROPERTY') {
        return this.$t('shopCommunityManage.deliveryTypeProperty')
      }
      return deliveryType || '-'
    },
    async _initData() {
      let shopId = await getShopId()
      this.shopCommunityManageInfo.conditions.shopId = shopId
      this._initCurrentShopState(shopId)
      this._listShopCommunitys(1, 10)
      try {
        const { data } = await getDict('s_shop_community', 'state')
        this.shopCommunityManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _initCurrentShopState(shopId) {
      const currentShop = getShop()
      this.currentShopState = currentShop.state || ''
      try {
        const res = await getShopList({ shopId, page: 1, row: 1 })
        if (res.data && res.data.length > 0) {
          this.currentShopState = res.data[0].state
        }
      } catch (error) {
        this.currentShopState = currentShop.state || ''
      }
    },
    async _listShopCommunitys(page, rows) {
      this.shopCommunityManageInfo.conditions.page = page
      this.shopCommunityManageInfo.conditions.row = rows
      try {
        const res = await queryShopCommunity(this.shopCommunityManageInfo.conditions)
        this.shopCommunityManageInfo.shopCommunitys = res.data
        this.shopCommunityManageInfo.total = res.total
        this.shopCommunityManageInfo.records = res.records
        console.log(this.shopCommunityManageInfo.records)
      } catch (error) {
        console.error('查询小区失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listShopCommunitys(val, this.shopCommunityManageInfo.conditions.row)
    },
    _queryShopCommunityMethod() {
      this._listShopCommunitys(1, this.shopCommunityManageInfo.conditions.row)
    },
    _resetShopCommunityMethod() {
      this.shopCommunityManageInfo.conditions = {
        state: '',
        communityId: '',
        communityNameLike: '',
        shopId: this.shopCommunityManageInfo.conditions.shopId,
        page: 1,
        row: 10
      }
      this._listShopCommunitys(1, 10)
    },
    _openAddShopCommunityModal() {
      if (!this.canApplyShopCommunity) {
        this.$message.warning('请先完成开店审核后再申请入驻小区')
        return
      }
      this.$refs.addShopCommunity.open()
    },
    _openDeleteShopCommunityModel(row) {
      this.$refs.deleteShopCommunity.open(row)
    },
    _openEditShopCommunityModel(row) {
      this.$refs.editShopCommunity.open(row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.ibox-title {
  padding: 15px 15px 7px;
  border-bottom: 1px solid #e7eaec;
  min-height: 48px;
}

.ibox-content {
  padding: 15px;
}
</style>
